import styled from "styled-components";

import { Button, AddButton, Link as DsLink } from "ds/Button";
import * as Sticker from "ds/Sticker";
import { semiBoldAlias } from "Libs/theme";

export const Link = styled(DsLink)`
  text-transform: none;
`;

export const Add = styled(AddButton)`
  float: right;
`;

export const Info = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  code {
    font-weight: normal;
  }
`;

export const Help = styled.p`
  margin: 16px 0 24px 0;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  svg {
    margin: 0 8px 0 0;
    vertical-align: middle;
  }
`;

export const Default = styled.div`
  margin: 0 0 0 8px;
  padding: 1px 8px 3px 8px;
  font-size: 12px;
  line-height: 20px;
  background: #efe7ff;
  border-radius: 2px;
  color: #9d67ff;
  ${semiBoldAlias()};
`;

export const ButtonLink = styled(Button)`
  white-space: nowrap;
`;

export const Domain = styled.span`
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: var(--section-ebony-color, var(--ebony));
`;

export const Date = styled.span`
  ${semiBoldAlias()};
  font-size: 13px;
  line-height: 24px;
  color: var(--section-slate-color, var(--slate));
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 32px;
`;
